<template>
	<div
		ref="container"
		:style="containerStyle"
		class="preview-container"
		@mouseenter="handleMouseEnter"
		@mouseleave="handleMouseLeave"
	>
		<slot />
	</div>
</template>

<script>
export default {
	name:  'PreviewContainer',
	props: {
		position: {
			type:    Object,
			default: null,
		},
	},
	data() {
		return {
			width:          null,
			containerWidth: 0,
		};
	},
	computed: {
		containerStyle() {
			if (!this.position) return {};
			const { bottom } = this.position;

			return {
				bottom:   `${bottom}px`,
				left:     `${this.left}px`,
				maxWidth: `${Math.floor(this.position.parent.width)}px`,
			};
		},
		left() {
			if (!this.position) return 0;
			const { parent, targetCenter } = this.position;
			let previewLeft = targetCenter.x - parent.left;

			if (this.width) {
				const diff = parent.right - this.width + previewLeft;

				if (diff < 0) {
					previewLeft = Math.max(0, previewLeft + diff);
				}

				previewLeft -= this.width / 2;

				const maxVal = parent.width - this.width;
				if (previewLeft < 0) previewLeft = 0;
				else if (previewLeft > maxVal) previewLeft = maxVal;
			}

			return previewLeft;
		},
	},
	mounted() {
		this.setContainerWidth();
		window.addEventListener('resize', this.setContainerWidth);
		this.updateContainerWidth();
		this.$nextTick(() => {
			this.updateContainerWidth();
		});

		document.addEventListener('touchend', this.handleTouchOutside);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.setContainerWidth);
		document.removeEventListener('touchend', this.handleTouchOutside);
	},
	methods: {
		updateContainerWidth() {
			if (!this.$refs.container) return;
			const val = this.$refs.container.offsetWidth;
			this.width = val;
		},
		handleMouseEnter(event) {
			this.$emit('mouseenter', event);
		},
		handleMouseLeave(event) {
			this.$emit('mouseleave', event);
		},
		setContainerWidth() {
			const offset = 40;
			this.containerWidth = window.innerWidth - offset;
		},
		handleTouchOutside(event) {
			if (this.$refs.container && !this.$refs.container.contains(event.target)) {
				event.stopPropagation();
				this.$emit('mouseleave', event);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.preview-container {
	@include z-index('timeline-tag-tooltip', 'full-page-overlays');
	position: absolute;
	background: var(--color-white);
	box-shadow: 0 4px 6px -1px rgba(var(--color-rgb-black), 0.1), 0 2px 4px -1px rgba(var(--color-rgb-black), 0.06);
	border-radius: 4px;
	padding: $sp3;
	margin-bottom: $sp4;
	transform: translateY(-4px);
	cursor: default;

	&::after {
		content: '';
		height: $sp4;
		width: 100%;
		display: block;
		position: absolute;
		top: 100%;
		left: 0;
	}
}
</style>
